import "core-js/modules/es6.array.iterator.js";
import "core-js/modules/es6.promise.js";
import "core-js/modules/es6.object.assign.js";
import "core-js/modules/es7.promise.finally.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import '~/node_modules/@web/shared-digital-library/icons/svg-originals/panier.svg';
var RATIOS = {
  '16:9': 'ri-16_9',
  '9:16': 'ri-9_16',
  '4:3': 'ri-4_3',
  '3:4': 'ri-3_4',
  '1:1': ''
};
export default {
  name: 'MainImage',
  props: {
    src: {
      type: String,
      default: ''
    },
    srcset: {
      type: String,
      default: ''
    },
    alt: {
      type: String,
      default: ''
    },
    ratio: {
      type: String,
      default: ''
    }
  },
  computed: {
    builderRatio: function builderRatio() {
      return RATIOS[this.ratio];
    }
  }
};